import { render, staticRenderFns } from "./page404All.vue?vue&type=template&id=4fd2e8e7&scoped=true&"
import script from "./page404All.vue?vue&type=script&lang=js&"
export * from "./page404All.vue?vue&type=script&lang=js&"
import style0 from "./page404All.vue?vue&type=style&index=0&id=4fd2e8e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2e8e7",
  null
  
)

export default component.exports